export default "__VITE_ASSET__Bl$jtpdb__"